import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAllExceptionList } from '../../../models/index';
import { IGetAllExceptionState } from '../../actions/types/exceptions/FetchAllExceptionListTypes';

/**
 * Initial All Event state in store
 */
const initialState: IGetAllExceptionState = {
  isLoading: false,
  eventErrorMessage: '',
  exception: {
    currentPageNumber: 0,
    numberOfRecordsPerPage: 10,
    totalRecords: 0,
    numberOfPages: 0,
    ersExceptions: [
      {
        ersExceptionUUId: '',
        ersExceptionName: '',
        ersExceptionDescription: '',
        ersExceptionType: '',
        status: '',
        version: 0,
        createdBy: '',
        createdTimestamp: '',
        updatedBy: '',
        updatedTimestamp: ''
      }
    ]
  }
};

const fetchAllExceptionListSlice = createSlice({
  name: 'fetchExceptionList',
  initialState,
  reducers: {
    fetchAllExceptionListStarted: (state) => {
      state.isLoading = true;
    },

    fetchExceptionListSuccess: (state, action: PayloadAction<IAllExceptionList>) => {
      state.isLoading = false;
      state.exception = action.payload;
      state.eventErrorMessage = '';
    },

    fetchAllExceptionListFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.exception = initialState.exception;
      state.eventErrorMessage = action.payload;
    },

    clearExceptionListDetails: (state) => {
      state.isLoading = false;
      state.exception = initialState.exception;
      state.eventErrorMessage = '';
    }
  }
});
export const {
  fetchAllExceptionListStarted,
  fetchExceptionListSuccess,
  fetchAllExceptionListFail,
  clearExceptionListDetails
} = fetchAllExceptionListSlice.actions;
export default fetchAllExceptionListSlice.reducer;
